import * as THREE from 'three';

export class OrthoSprite extends THREE.Object3D {
  type: string;
  offset: any;
  renderSprite: any;
  baseWidth: number;
  baseHeight: number;
  currentTime: number;

  constructor(material?: any, offset?: any) {
    super();

    this.type = 'OrthoSprite';
    this.baseWidth = 0;
    this.baseHeight = 0;
    this.currentTime = 0;

    this.offset = (offset !== undefined) ? offset : new THREE.Vector2(0, 0);

    if (material === undefined) material = new THREE.SpriteMaterial();
    this.renderSprite = new THREE.Sprite(material);
  }

  clone(object?: any) {
    if (object === undefined) {
      object = new OrthoSprite(this.renderSprite.material, this.offset);
    }

    super.clone.call(this, object);

    return object;
  }
}
